import React from "react";
import { NameFields } from "@ca-dmv-radv/components";
import { useTranslation } from "@ca-dmv-radv/translation";
import { APPLICATION_TYPE } from "@ca-dmv-radv/data";
import SelectDocument from "./SelectDocument";

export default function FormFields({
  firstName,
  setFirstName,
  middleName,
  setMiddleName,
  suffix,
  setSuffix,
  lastName,
  setLastName,
  errors,
  showErrors,
  focusedElementKey,
  setCatDocId,
  catDocId,
  nameChangeDocuments,
  applicationType,
}) {
  const { t } = useTranslation();

  return (
    <>
      <NameFields
        namePrompt={t(
          "screens-confirm-name-whatNameWouldYouLikeToAdd",
          "What name would you like to add?"
        )}
        firstName={firstName}
        middleName={middleName}
        lastName={lastName}
        suffix={suffix}
        onChangeFirstName={setFirstName}
        onChangeMiddleName={setMiddleName}
        onChangeLastName={setLastName}
        onChangeSuffix={setSuffix}
        translatedErrors={errors}
        showErrors={showErrors}
        focusedElementKey={focusedElementKey}
      />
      <SelectDocument
        legend={t(
          applicationType === APPLICATION_TYPE.NCH
            ? "nch-screens-confirm-name-certifyingDocumentLegend"
            : "screens-confirm-name-certifyingDocumentLegend",
          applicationType === APPLICATION_TYPE.NCH
            ? "Select the document type that certifies the above name."
            : "Which document certifies this name change?"
        )}
        documentList={nameChangeDocuments}
        onChange={(nextValue) => {
          setCatDocId(Number(nextValue));
        }}
        error={errors && showErrors && errors.certifyingDoc}
        documentId={catDocId}
        name="certifyingDoc"
        selectLabel={t(
          "screens-confirm-namme-selectDocument",
          "Select one of the documents below"
        )}
        required
        idField="id"
      />
    </>
  );
}
